import { Box, useTheme } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';

function DiscoverAppPanel() {
  const theme = useTheme();
  const { discoveryApprovals } = useSelector(({ admissionFeeReducer }) => {
    return {
      discoveryApprovals: admissionFeeReducer.mgmentPanel,
    };
  });
  return (
    <Box>
      <Box
        border={1}
        display="flex"
        flex={4}
        borderColor={theme.palette.buzzBorder}
        p={2}
        mb={9}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          flex={1}
          borderRight={`1px solid ${theme.palette.buzzBorder}`}>
          <Box mb={1} fontSize={18} color={theme.palette.buzzGreyTextColor}>
            Approvals Pending
          </Box>
          <Box
            minWidth={130}
            fontSize={48}
            // fontWeight={700}
            sx={{ textAlign: 'center' }}>
            {discoveryApprovals ? discoveryApprovals.requestedReviews : 0}
          </Box>
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          flex={1}
          borderRight={`1px solid ${theme.palette.buzzBorder}`}>
          <Box mb={1} fontSize={18} color={theme.palette.buzzGreyTextColor}>
            Approvals Given
          </Box>
          <Box
            minWidth={130}
            fontSize={48}
            // fontWeight={700}
            sx={{ textAlign: 'center' }}>
            {discoveryApprovals ? discoveryApprovals.approvedReviews : 0}
          </Box>
        </Box>
        <Box display="flex" flexDirection="column" alignItems="center" flex={1}>
          <Box mb={1} fontSize={18} color={theme.palette.buzzGreyTextColor}>
            Approvals Pending
          </Box>
          <Box
            minWidth={120}
            fontSize={48}
            // fontWeight={700}
            sx={{ textAlign: 'center' }}>
            {discoveryApprovals ? discoveryApprovals.rejectedReview : 0}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default DiscoverAppPanel;
